import React from 'react';
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { State, Store } from '@sambego/storybook-state';
import MyIcscCarousel from './index';
import CAROUSEL_DATA from '../../../testing/data/carousel';

const mock = new MockAdapter(axios, { delayResponse: 2000 });

const store = new Store({
    slides: [],
    isLoading: true,
});

// storiesOf('My ICSC/Carousel', MyIcscCarousel)
//     .addParameters({
//         component: MyIcscCarousel,
//         parameters: {
//             docs: {
//                 description: {
//                     story: 'some story **markdown**',
//                 },
//             },
//         },
//     })
//     .add(
//         'with slides',
//         withState({ isLoading: true, slides: [] })(({ store }) => {
//             mock.onPost('/api/carousel').reply(200, CAROUSEL_DATA.data);
//             return <MyIcscCarousel section="dashboard" />;
//         })
//     );

export default {
    title: 'My ICSC/My ICSC Carousel',
    component: MyIcscCarousel,
    parameters: {
        docs: {
            description: {
                component: 'some component _markdown_',
            },
        },
    },
};

mock.onPost('/api/carousel').reply(200, CAROUSEL_DATA.data);
export const withSlides = () => (
    <State store={store}>
        <MyIcscCarousel section="dashboard" />
    </State>
);
